<template>
    <div
        class="modal-card repair-analysis-info has-text-black"
        style="width: auto"
    >
        <header class="modal-card-head">
            <p class="title is-4 has-text-black">
                {{ $t('repairAnalysisInfo.headline') }}
            </p>
        </header>
        <div class="modal-card-body has-background-light">
            <div class="info-list">
                <div class="entry">
                    <span class="entry__label">{{
                        $t('repairAnalysisInfo.numberOfFlippedPolygons')
                    }}</span
                    ><span class="entry__value">{{
                        repairAnalysisInfo.numberOfFlippedPolygons
                    }}</span>
                </div>
                <div class="entry">
                    <span class="entry__label">
                        {{
                            $t(
                                'repairAnalysisInfo.numberOfRemovedFlatOpenShells'
                            )
                        }} </span
                    ><span class="entry__value">{{
                        repairAnalysisInfo.numberOfRemovedFlatOpenShells
                    }}</span>
                    <div class="entry">
                        <span class="entry__label"
                            >{{
                                $t('repairAnalysisInfo.numberOfClosedOpenLoops')
                            }} </span
                        ><span class="entry__value">{{
                            repairAnalysisInfo.numberOfClosedOpenLoops
                        }}</span>
                    </div>
                    <div class="entry">
                        <span class="entry__label"
                            >{{
                                $t(
                                    'repairAnalysisInfo.numberOfMergedVertexPairs'
                                )
                            }} </span
                        ><span class="entry__value">{{
                            repairAnalysisInfo.numberOfMergedVertexPairs
                        }}</span>
                    </div>
                </div>
                <p class="title is-4 has-text-black mt-5">
                    {{ $t('repairAnalysisInfo.repairPictureHeadline') }}
                </p>
                <div class="has-background-white">
                    <RepairPictures></RepairPictures>
                </div>
                <p class="is-size-6 mt-3">
                    {{ $t('repairAnalysisInfo.repairPictureControls') }}
                </p>
                <p class="mt-3">
                    <strong>
                        {{ $t('repairAnalysisInfo.fileIsReadyForPrinting') }}
                    </strong>
                </p>
            </div>
        </div>
        <div
            class="repair-actions modal-card-foot is-justify-content-space-between"
        >
            <a
                :href="`${apiBaseUrl}/analytx${current3DFile.files.repaired}`"
                class="button button-light"
                >{{ $t('repairAnalysisInfo.downloadFile') }}</a
            >
            <button class="button is-primary-dark" @click="close()">
                {{ $t('repairAnalysisInfo.continue') }}
            </button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { eventBus } from '../../../events/event-bus';
import RepairPictures from './RepairPictures';

export default {
    name: 'RepairAnalysisInfo',
    components: { RepairPictures },
    data() {
        return { apiBaseUrl: process.env.VUE_APP_FULFILLMENT_API_BASE_URL };
    },
    methods: {
        close() {
            eventBus.$emit('close-modal-event');
            this.$parent.close();
        },
    },
    computed: {
        ...mapGetters(['current3DFile']),
        repairAnalysisInfo() {
            return this.current3DFile.repairInfo;
        },
    },
};
</script>

<style lang="scss"></style>
